/* eslint-disable react/jsx-no-literals */
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { marketType } from '@propTypes';
import { get } from 'lodash';
import { Spinner } from '@components/shared';
import renderingInServer from '@shared/renderingInServer';
import s from './ResultsHeaderText.module.less';

const ResultsHeaderText = ({
  numListings,
  selectedMarkets,
  defaultMarketName,
  isCustomMapArea,
  isLoading,
}) => {
  if (renderingInServer()) {
    return null;
  }

  let countPrefix;
  if (isLoading) {
    countPrefix = <Spinner />;
  } else {
    countPrefix = <strong>{numListings}</strong>;
  }

  if (isCustomMapArea) {
    const translatedStringCustomMap = (
      <Trans i18nKey="resultsHeaderWithCustomArea" ns="listingSearch">
        Results in
        <strong>Custom Map Area</strong>
      </Trans>
    );

    return (
      <h2 className={s.header}>
        {countPrefix} {translatedStringCustomMap}
      </h2>
    );
  }

  const marketOne = get(selectedMarkets, [0, 'name']);
  const marketTwo = get(selectedMarkets, [1, 'name']);
  const marketThree = get(selectedMarkets, [2, 'name']);
  const excessMarkets = selectedMarkets.length - 3;

  let translatedString;
  switch (selectedMarkets.length) {
    case 0:
      translatedString = defaultMarketName ? (
        <Trans i18nKey="resultsHeaderWithOneMarket" ns="listingSearch">
          Results in
          <strong>{{ marketOne: defaultMarketName }}</strong>
        </Trans>
      ) : (
        <Trans i18nKey="resultsHeaderWithNoMarkets" ns="listingSearch">
          Results
        </Trans>
      );
      break;
    case 1:
      translatedString = (
        <Trans i18nKey="resultsHeaderWithOneMarket" ns="listingSearch">
          Results in <strong>{{ marketOne }}</strong>
        </Trans>
      );
      break;
    case 2:
      translatedString = (
        <Trans i18nKey="resultsHeaderWithTwoMarkets" ns="listingSearch">
          Results in
          <strong>
            {{ marketOne }} & {{ marketTwo }}
          </strong>
        </Trans>
      );
      break;
    case 3:
      translatedString = (
        <Trans
          i18nKey="resultsHeaderWithThreeMarkets"
          ns="listingSearch"
          values={{ marketThree, marketTwo, marketOne, numListings }}
        >
          Results in
          <strong>
            {{ marketOne }}, {{ marketTwo }} & {{ marketThree }}
          </strong>
        </Trans>
      );
      break;
    default:
      translatedString = (
        <Trans i18nKey="resultsHeaderWithMoreThanThreeMarkets" ns="listingSearch">
          Results in
          <strong>
            {{ marketOne }}, {{ marketTwo }}, {{ marketThree }} +{{ excessMarkets }}
          </strong>
        </Trans>
      );
      break;
  }

  return (
    <h2 className={s.header}>
      {countPrefix} {translatedString}
    </h2>
  );
};

ResultsHeaderText.defaultProps = {
  defaultMarketName: null,
  isCustomMapArea: false,
  isLoading: false,
};

ResultsHeaderText.propTypes = {
  numListings: PropTypes.number.isRequired,
  selectedMarkets: PropTypes.arrayOf(marketType).isRequired,
  isCustomMapArea: PropTypes.bool,
  isLoading: PropTypes.bool,
  defaultMarketName: PropTypes.string,
};
export default ResultsHeaderText;
